import { Phone, MessageCircle, MapPin, Clock, Mail } from "lucide-react";
import { COMPANY, waLink } from "@/data/site";
import { SEO } from "@/components/SEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { ContactForm } from "@/components/ContactForm";

export default function Contato() {
  return (
    <>
      <SEO
        title="Contato | Desentupidora Paulistana 24h em São Paulo"
        description={`Fale com a Desentupidora Paulistana. Atendimento 24h nos bairros nobres de São Paulo. WhatsApp e telefone ${COMPANY.phoneDisplay}.`}
        path="/contato"
      />
      <section className="bg-brand-black text-white">
        <div className="max-w-7xl mx-auto container-px py-14">
          <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Contato" }]} />
          <h1 className="font-display font-black text-4xl sm:text-5xl mt-4 mb-3">Fale Conosco</h1>
          <p className="text-gray-300 max-w-2xl">Atendimento de emergência 24 horas. Chame agora pelo WhatsApp ou telefone.</p>
        </div>
      </section>

      <section className="bg-white">
        <div className="max-w-7xl mx-auto container-px py-16 grid lg:grid-cols-2 gap-12">
          <div>
            <h2 className="font-display font-extrabold text-2xl text-brand-black mb-6">Canais de atendimento</h2>
            <ul className="space-y-5">
              <li className="flex items-start gap-4">
                <span className="grid place-items-center w-11 h-11 rounded-lg bg-brand-red shrink-0"><Phone className="w-5 h-5 text-white" /></span>
                <div>
                  <span className="block text-sm text-gray-500">Telefone</span>
                  <a href={`tel:${COMPANY.phoneTel}`} className="font-display font-bold text-lg text-brand-black hover:text-brand-red transition-colors">{COMPANY.phoneDisplay}</a>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <span className="grid place-items-center w-11 h-11 rounded-lg bg-wa-green shrink-0"><MessageCircle className="w-5 h-5 text-white" /></span>
                <div>
                  <span className="block text-sm text-gray-500">WhatsApp</span>
                  <a href={waLink()} target="_blank" rel="noopener noreferrer" className="font-display font-bold text-lg text-brand-black hover:text-wa-green transition-colors">{COMPANY.phoneDisplay}</a>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <span className="grid place-items-center w-11 h-11 rounded-lg bg-brand-gray shrink-0"><MapPin className="w-5 h-5 text-white" /></span>
                <div>
                  <span className="block text-sm text-gray-500">Endereço</span>
                  <span className="font-medium text-brand-black">{COMPANY.address}, CEP {COMPANY.cep}</span>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <span className="grid place-items-center w-11 h-11 rounded-lg bg-brand-gray shrink-0"><Clock className="w-5 h-5 text-white" /></span>
                <div>
                  <span className="block text-sm text-gray-500">Horário</span>
                  <span className="font-medium text-brand-black">{COMPANY.hours}</span>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <span className="grid place-items-center w-11 h-11 rounded-lg bg-brand-gray shrink-0"><Mail className="w-5 h-5 text-white" /></span>
                <div>
                  <span className="block text-sm text-gray-500">E-mail</span>
                  <span className="font-medium text-brand-black">{COMPANY.email}</span>
                </div>
              </li>
            </ul>
            <p className="text-xs text-gray-400 mt-6">CNPJ: {COMPANY.cnpj}</p>
          </div>
          <div>
            <ContactForm />
          </div>
        </div>
      </section>
    </>
  );
}
